import { InvalidInputError } from '@exodus/web3-errors';
import { serializeBytes } from '@exodus/web3-serialization';
const createBtcDepsFactory = () => {
    return ({ assetName, broadcastTx, getAddress, getPaymentAddressPurpose, getOrdinalsAddressPurpose, getPublicKey, getActiveWalletAccountData, transactionSigner, messageSigner, txSend, logger, }) => {
        const getAccounts = async ({ purposes, publicKeyEncoding = 'base64', returnPurposeNumbers = false, }) => {
            const retrieveAddressAndPublicKeyForPurpose = async (_purpose) => {
                let address, publicKeyToEncode, purposeNumber;
                const walletAccount = await getActiveWalletAccountData();
                const getAddressPurposeParams = {
                    assetName,
                    walletAccount,
                };
                if (_purpose === 'ordinals') {
                    if (!getOrdinalsAddressPurpose) {
                        return null;
                    }
                    purposeNumber = await getOrdinalsAddressPurpose(getAddressPurposeParams);
                    address = await getAddress(assetName, purposeNumber);
                    const publicKey = await getPublicKey(assetName, purposeNumber);
                    // A compressed public key, we have to chop the first byte.
                    publicKeyToEncode = publicKey.slice(1);
                }
                else if (_purpose === 'payment') {
                    if (!getPaymentAddressPurpose) {
                        return null;
                    }
                    // The `purpose` is dynamic and depends on the compatibility mode in the client.
                    purposeNumber = await getPaymentAddressPurpose(getAddressPurposeParams);
                    // Payment address is dynamic as well as it depends on the purpose number.
                    address = await getAddress(assetName, purposeNumber);
                    const publicKey = await getPublicKey(assetName, purposeNumber);
                    publicKeyToEncode = publicKey;
                }
                else {
                    throw new InvalidInputError(`Unknown purpose: ${_purpose}`);
                }
                const baseResponse = {
                    address,
                    publicKey: serializeBytes(publicKeyToEncode, publicKeyEncoding),
                    purpose: _purpose,
                    ...(walletAccount.isHardware
                        ? {
                            hardwareWallet: {
                                manufacturer: walletAccount.source,
                            },
                        }
                        : {}),
                };
                if (!returnPurposeNumbers) {
                    return baseResponse;
                }
                return {
                    ...baseResponse,
                    purposeNumber,
                };
            };
            return Promise.all(purposes.map(retrieveAddressAndPublicKeyForPurpose));
        };
        return {
            chainId: 'undefined',
            assetName,
            broadcastTx,
            getAccounts,
            getActiveWalletAccountData,
            transactionSigner,
            messageSigner,
            txSend,
            logger,
        };
    };
};
export default createBtcDepsFactory;
